import * as React from "react";

interface IProps {
    text: string;
}

export const EditableText: React.FC<IProps> = ({ text }) => {
    const [isEditing, setIsEditing] = React.useState(false);
    const [value, setValue] = React.useState(text);

    const handleClick = () => setIsEditing(true);
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => setValue(e.target.value);

    const handleBlur = () => {
        const formatted = formatText(value);
        setValue(formatted === "" ? text : formatted);
        setIsEditing(false);
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            e.currentTarget.blur();
        }
    };

    const formatText = (str: string): string =>
        str.trim().replace(/\s+/g, " ");

    return isEditing ? (
        <input
            type="text"
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
            autoFocus
            style={{ width: "100%" }}
        />
    ) : (
        <div
            onClick={handleClick}
            style={{
                cursor: "pointer",
                width: "100%",
                height: "100%",
                display: "block",
                }}
        >
            {value}
        </div>
    );
};
